import BaseService from '../../services/BaseService';
import axios from 'axios';

class CourseCompletionService extends BaseService {

  async downloadCertificate(id) {
    return axios.get(`${this.url}/${id}/certificate/download`, {
      responseType: 'blob'
    });
  }

  async viewCertificateInline(id) {
    return axios.get(`${this.url}/${id}/certificate/view`, {
      responseType: 'blob'
    });
  }

  async verifyCertificate(id, roll_number, mobile) {
    return await axios.post(`${this.url}/${id}/verify`, { roll_number, mobile },
      {
        responseType: 'blob',
        validateStatus: (status) => status < 500
      }
    );
  }

  async resendCertificateEmail(id) {
    return await axios.post(`${this.url}/${id}/resend_certificate_email`, {}, { validateStatus: (status) => status < 500 }
    );
  }

  async getPublicRecord(id) {
    return await axios.get(`${this.url}/${id}/public`, { validateStatus: (status) => status < 500}
    );
  }

  async uploadCsv(params) {
    return await axios.post(`${this.url}/upload_csv`, params);
  }

  async bulkInsert(params) {
    return await axios.post(`${this.url}/bulk_insert`, params);
  }

  async downloadCertificatesAsZip(params) {
    return await axios.get(`${this.url}/download/certificates/zip`, {
      params,
      responseType: 'blob'
    });
  }

}

export default new CourseCompletionService('health_backend', 'course_completions');